/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Impostazioni from './pages/Impostazioni';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Utenti from './pages/Utenti';
import Strumenti from './pages/Strumenti';
import Materiali from './pages/Materiali';
import Fornitori from './pages/Fornitori';
import InventarioCliente from './pages/InventarioCliente';
import Interventi from './pages/Interventi';
import InterventoDetail from './pages/InterventoDetail';
import Report from './pages/Report';
import Prodotti from './pages/Prodotti';
import Notifiche from './pages/Notifiche';
import Privacy from './pages/Privacy';
import RichiestePrivacy from './pages/RichiestePrivacy';
import Fatturazione from './pages/Fatturazione';
import Segnalazioni from './pages/Segnalazioni';
import Calendario from './pages/Calendario';
import { useIdentitaApp } from './hooks/useImpostazioni';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30 * 1000 },
  },
});

// Applica nome e icona dell'installazione a titolo della scheda e favicon.
// Sta dentro il provider di react-query perche' legge le impostazioni.
function IdentitaApp() {
  useIdentitaApp('admin', 'Admin');
  return null;
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <IdentitaApp />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/richieste-privacy" element={<ProtectedRoute requiredRole="admin"><RichiestePrivacy /></ProtectedRoute>} />
            <Route path="/dashboard"       element={<ProtectedRoute requiredRole="admin"><Dashboard /></ProtectedRoute>} />
            <Route path="/utenti"          element={<ProtectedRoute requiredRole="admin"><Utenti /></ProtectedRoute>} />
            <Route path="/strumenti"       element={<ProtectedRoute requiredRole="admin"><Strumenti /></ProtectedRoute>} />
	    <Route path="/prodotti"        element={<ProtectedRoute requiredRole="admin"><Prodotti /></ProtectedRoute>} />
     	    <Route path="/notifiche"       element={<ProtectedRoute requiredRole="admin"><Notifiche /></ProtectedRoute>} />
            <Route path="/materiali"       element={<ProtectedRoute requiredRole="admin"><Materiali /></ProtectedRoute>} />
            <Route path="/fornitori"      element={<ProtectedRoute requiredRole="admin"><Fornitori /></ProtectedRoute>} />
            <Route path="/inventari/:clienteId" element={<ProtectedRoute requiredRole="admin"><InventarioCliente /></ProtectedRoute>} />
            <Route path="/interventi"      element={<ProtectedRoute requiredRole="admin"><Interventi /></ProtectedRoute>} />
            <Route path="/interventi/:id"  element={<ProtectedRoute requiredRole="admin"><InterventoDetail /></ProtectedRoute>} />
            <Route path="/report"          element={<ProtectedRoute requiredRole="admin"><Report /></ProtectedRoute>} />
            <Route path="/fatturazione"    element={<ProtectedRoute requiredRole="admin"><Fatturazione /></ProtectedRoute>} />
            <Route path="/segnalazioni"    element={<ProtectedRoute requiredRole="admin"><Segnalazioni /></ProtectedRoute>} />
            <Route path="/calendario"      element={<ProtectedRoute requiredRole="admin"><Calendario /></ProtectedRoute>} />
            <Route path="/impostazioni"    element={<ProtectedRoute requiredRole="admin"><Impostazioni /></ProtectedRoute>} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
}
